import { Component, OnInit } from '@angular/core';
import { AppMainComponent } from './app.main.component';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {

    model: any[];

    constructor(public app: AppMainComponent) {}

    ngOnInit() {
        this.model = [
            {   label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/']},
            {   label: 'Templates', icon: 'pi pi-fw pi-palette', routerLink: ['/templates'] },
            {   label: 'Predictions', icon: 'pi pi-fw pi-eye', routerLink: ['/predictions'] }
        ];
    }
}
